import script from "./DealTask.vue?vue&type=script&setup=true&lang=js"
export * from "./DealTask.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__